import { createFileRoute, redirect } from '@tanstack/react-router';

// The Analyses screen merged into Conversations (quality columns + filters).
// Keep the route as a redirect so old bookmarks and deep links survive.
export const Route = createFileRoute('/analyses')({
  beforeLoad: () => {
    throw redirect({ to: '/records' });
  },
});
